import { Typography } from '@mui/material';
import { formatContactDetail } from './FormatContactDetail';

interface Props {
  contactDetail: string;
}

export const ContactText = ({ contactDetail }: Props) => {
  return <Typography variant="body2">{formatContactDetail({ contactDetail })}</Typography>;
};
